import { lazy } from 'react';
import { appConstants } from './constants';

/**
 * router configuration and mapped components.
 *
 * export {
 *   routes
 * }
 */
const Home = lazy(() => import('../../presentation/containers/home'));
const Results = lazy(() => import('../../presentation/containers/results'));
const Browse = lazy(() => import('../../presentation/containers/browse'));
const Logout = lazy(() => import('../../presentation/containers/logout'));

const routes = [
  {
    path: appConstants.routePaths.home,
    component: Home,
    authRequired: true
  },
  {
    path: appConstants.routePaths.results,
    component: Results,
    authRequired: true
  },
  {
    path: appConstants.routePaths.browse,
    component: Browse,
    authRequired: true
  },
  {
    path: appConstants.routePaths.logout,
    component: Logout
  },
  {
    path: '/*',
    component: Home,
    authRequired: true
  }
];
export { routes };
